import { render, staticRenderFns } from "./WiaaEditId.vue?vue&type=template&id=1f02ef00&scoped=true&"
import script from "./WiaaEditId.vue?vue&type=script&lang=js&"
export * from "./WiaaEditId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f02ef00",
  null
  
)

export default component.exports